import {
    LESSON_REQUEST_FLOW_ORDER,
    LESSON_REQUEST_TYPES,
    getRequestTypeMeta,
} from "constants/lessonRequest";
import StarIcon from '@mui/icons-material/Star';
import MaskIcon from '@mui/icons-material/HealthAndSafety'; // Fallback for mask
import TicketIcon from '@mui/icons-material/LocalActivity';

export default function Step1RequestType({ onSelect, selectedType, onHistoryClick }) {
    const getIcon = (type) => {
        if (type === LESSON_REQUEST_TYPES.PREMIUM) return <StarIcon />;
        if (type === LESSON_REQUEST_TYPES.TRIAL) return <MaskIcon />;
        return <TicketIcon />;
    };

    return (
        <div className="step-view">
            <div className="title-section">
                <h2>어떤 수업을 원하세요?</h2>
                <p>요청하는 수업이 무엇인지 선택해주세요</p>
            </div>
            <div className="lesson-request-start-tools">
                <button
                    type="button"
                    className="lesson-request-history-link"
                    onClick={onHistoryClick}
                >
                    신청 내역 보기
                </button>
            </div>
            <div className="card-stack">
                {LESSON_REQUEST_FLOW_ORDER.map((type) => {
                    const meta = getRequestTypeMeta(type);
                    const isSelected = selectedType === type;
                    return (
                        <button
                            key={type}
                            type="button"
                            className={`request-type-card ${isSelected ? "is-selected" : ""}`}
                            onClick={() => onSelect(type)}
                        >
                            <div className="request-type-card__icon-box">
                                {getIcon(type)}
                            </div>
                            <div className="request-type-card__body">
                                <strong>{meta.title}</strong>
                                <small>{meta.description}</small>
                                <div className="request-type-card__tags">
                                    {meta.tags?.map((tag) => (
                                        <em key={tag}>{tag}</em>
                                    ))}
                                </div>
                            </div>
                        </button>
                    );
                })}
            </div>
        </div>
    );
}
